module.exports = "/_next/static/images/51557655e361dc6eb3db4eb1888d0be5-perks-075x.jpg.webp";